import './modules/media-queries.js';
import './components/index.js';
import './sections/index.js';
import './modules/klaviyo.js';
import './modules/moon-routine.js';

import * as matchMedia from './modules/match-media.js';

matchMedia.set('wide', '(min-width: 1441px)');
matchMedia.set('large', '(min-width: 1024px) and (max-width: 1440px)');
// matchMedia.set('medium', '(min-width: 761px) and (max-width: 1024px)');
matchMedia.set('small', '(max-width: 1023px)');

// klaviyoForms
window.addEventListener("klaviyoForms", function (e) {
  // console.log('Klaviyo form:', e);
  if (e.detail.type === 'submit') {
    fbq('track', 'Lead');
  }
});
